import $ from 'jquery';
import BaseEvent from './base-event';

export default class SecondMenuEvents extends BaseEvent {
    constructor() {
        super({
            event_id: '6',
            category: 'second_menu',
        });

        this.init();
    }

    init() {
        this.onSecondMenuClick();
    }

    onSecondMenuClick() {
        $('a.mc-tabs-nav__item-link').on('click', (e) => {
            const action = this.getAction($(e.currentTarget));
            const label = this.getLabel($(e.currentTarget));
            this.fireEvent({
                destination_url: e.currentTarget.href,
                action: action ? this.toNormalizedString(action) : null,
                label: this.toNormalizedString(label),
            });
        });
    }

    getAction($currentTarget) {
        let action = null;

        if (!action) {
            action = this.getLabel($currentTarget.closest('.next-fixtures').find('h2')) || null;
        }
        if (!action) {
            action = $('.mc-header-sub-nav__link--is-selected').get(0)?.innerText || null;
        }
        if (!action) {
            action = $('.mc-main-content').find('h1').get(0)?.innerText || null;
        }
        if (!action) {
            action = $('.mc-header-primary-nav')
                .find('.mc-header-primary-nav__link--underline, .mc-header-primary-nav__item--is-selected a')
                .get(0)?.innerText || null;
        }
        return action;
    }
}
